import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type NavAction, type NavItem, type NavItemContext } from '@/common/types/navigation'
import { type IModuleContext } from '@/common/types/module'

export class SmsNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(context: IModuleContext, action: NavAction<any>) {
    super(context, action)
    this.textKey = 'assist.action.sms'
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    const skillGroupId = action.actionData?.skillGroupId

    if (skillGroupId) {
      yield {
        ...this.getDefaultNavigationItem(action, itemContext),
        category: action.actionData.action,
        target: `/assist/sms/create/${skillGroupId}${this.context.getUrlParams()}`,
      } as NavItem
    }
  }
}
